/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Resources_Guide_Start_Step4Inputs */

const en_gc_resources_guide_start_step4 = /** @type {(inputs: Gc_Resources_Guide_Start_Step4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use the save or export control to download an XLSX copy. Reopen that file and check your edits before replacing your original.`)
};

const zh_gc_resources_guide_start_step4 = /** @type {(inputs: Gc_Resources_Guide_Start_Step4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`使用保存或导出控件下载 XLSX 副本。重新打开并检查修改，再决定是否替换原文件。`)
};

/**
* | output |
* | --- |
* | "Use the save or export control to download an XLSX copy. Reopen that file and check your edits before replacing your original." |
*
* @param {Gc_Resources_Guide_Start_Step4Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_resources_guide_start_step4 = /** @type {((inputs?: Gc_Resources_Guide_Start_Step4Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Resources_Guide_Start_Step4Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_resources_guide_start_step4(inputs)
	return zh_gc_resources_guide_start_step4(inputs)
});
export { gc_resources_guide_start_step4 as "gc.resources.guide.start.step4" }